exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outputer{transition:all .5s ease;box-sizing:border-box;height:100%;width:50%;padding:15px;resize:none;border:none;outline:none;font-family:inherit;font-size:18px;white-space:normal;overflow-y:scroll;word-wrap:break-word}.outputer img{max-width:100%;margin:0 auto;display:block}.outputer .emoji{height:1em;display:inline}div.outputer.fullscreen{display:none}div.outputer.preview{width:100%;max-width:1200px}.outputer.theme-day{background-color:#f5f5f5;color:#616161;box-shadow:4px 5px 3px #aaa}.outputer.theme-night{background-color:#4d4d4d;color:#b3b3b3;box-shadow:4px 5px 3px #1f1f1f}.outputer.theme-night pre{background-color:#262626;border-color:#1a1a1a;color:#839496}.outputer.theme-night code{background-color:#262626;color:#657b83}.outputer.theme-night blockquote{border-left-color:#262626;background:#595959}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ac847d2","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/outputer.vue
// module id = 359
// module chunks = 0